import _ from "lodash";
import { flushSync } from "react-dom";
import Axios from "Source/axiosPool";
import {  validateEmail } from "Source/globalFunction";

export const UserStatusEnum = {
    ACTIVE : "active",
    INACTIVE : "inactive",
    INVITED : "invited",
    DEACTIVATED : "deactivated"
}

const exportFields = ({state, type, onSetState, project}) => {
    const onSelectRole = (value) => {
        onSetState({data: {...state.data, userRole: value}});
    }

    const onChange = _.debounce((key, value) => {
        flushSync(() => onSetState({data: {...state.data, isTyping: true, [key]: value}}));
        
        if(key === "username" || key === "emailAddress") { 
            onSetState({ isTyping: false, emailHasError: false, errorType:'' });
            if (!validateEmail(value) && key === "emailAddress" && value.length) {
                onSetState({ isTyping: false, emailHasError: true, errorType:'invalid' });
            } else {
                onChecking(key, value);
            }
        }
    }, 300);
    
    const onChecking = (key, value) => {
        if(value && project.members.map(m => (m[key]||'').trim()).filter(f=>f).indexOf(value.trim()) > -1) {
            if(key === "emailAddress") {
                onSetState({emailHasError: true});
            } else {
                onSetState({usernameHasError: true});
            }
        } else {
            if(value) {
                const url = "api/user/checkUser";
                const params = { 
                    field: key, 
                    value: value,
                    cancellable: true
                };
                
                Axios.get(url, params)
                    .then(response => {
                        if(response) {
                            if((response.data || {}).error) {
                                if(key === "emailAddress") {
                                    onSetState({isTyping: false, emailHasError: true});
                                } else {
                                    onSetState({isTyping: false, usernameHasError: true});
                                }
                            } else {
                                if(key === "emailAddress") {
                                    onSetState({isTyping: false, emailHasError: false});
                                } else {
                                    onSetState({isTyping: false, usernameHasError: false});
                                }
                            }
                        }
                    });
            } else {
                if(key === "emailAddress") {
                    onSetState({isTyping: false, emailHasError: false});
                } else {
                    onSetState({isTyping: false, usernameHasError: false});
                }
            }
        }
    };

    const Fields = {
        External: {
            main: {
                userType: {
                    required: true,
                    type: "display",
                    label: "User Type",
                    value: type
                },
                userRole: {
                    type: "select",
                    required: true,
                    label: "User Role",
                    classes: {options: `userRoleSelect`},
                    options: [{value: 5, label: "External Manager"}, {value: 6, label: "External Guest"}],
                    value: state.data.userRole,
                    onChange: onSelectRole
                },
                username: {
                    type: "text",
                    required: true,
                    label: "Username",
                    hasError: state.usernameHasError,
                    errorMessage: "Username already exists!",
                    value: state.data.username,
                    onChange: e => onChange("username", e.target.value)
                },
                firstName: {
                    type: "text",
                    required: true,
                    label: "First Name",
                    value: state.data.firstName,
                    onChange: e => onChange("firstName", e.target.value)
                },
                lastName: {
                    type: "text",
                    required: true,
                    label: "Last Name",
                    value: state.data.lastName,
                    onChange: e => onChange("lastName", e.target.value)
                },
                emailAddress: {
                    type: "text",
                    required: true,
                    label: "Email Address",
                    hasError: state.emailHasError,
                    errorMessage: state.errorType==='invalid'?"Invalid Email Address":"Email already exists!",
                    value: state.data.emailAddress,
                    onChange: e => onChange("emailAddress", e.target.value)
                },
                phoneNumber: {
                    type: "text",
                    required: false,
                    label: "Contact Number",
                    value: state.data.phoneNumber,
                    onChange: e => onChange("phoneNumber", e.target.value)
                }
            },
            others: {
                company: {
                    required: false,
                    type: "display",
                    label: "Company",
                    value: project.project
                },
                position: {
                    type: "text",
                    required: false,
                    label: "Position",
                    value: state.data.position,
                    onChange: e => onChange("position", e.target.value),
                    retainedField: true
                }
            }
        },
        Internal: {
            main: {
                userType: {
                    required: true,
                    label: "User Type",
                    value: type
                },
                userRole: {
                    required: true,
                    label: "User Role",
                    value: state.data.userRole
                },
                username: {
                    required: true,
                    label: "Username",
                    value: state.data.username
                },
                firstName: {
                    required: true,
                    label: "First Name",
                    value: state.data.firstName,
                },
                lastName: {
                    required: true,
                    label: "Last Name",
                    value: state.data.lastName,
                },
                position: {
                    label: "Position",
                    value: state.data.position,
                },
                emailAddress: {
                    required: true,
                    label: "Email Address",
                    value: state.data.emailAddress
                },
                phoneNumber: {
                    label: "Contact Number",
                    value: state.data.phoneNumber
                },
                supervisors: {
                    label: "Supervisor/s",
                    value: state.data.supervisors
                }
            },
            others: {}
        },
        null: {
            main: {},
            others: {}
        }
    }

    return Fields[type];
}

export default exportFields;